const tabs = document.querySelectorAll('[id^="tab--"]');
tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
        tabs.forEach((tab) => {
            tab.classList.remove('active');
        });
        e.currentTarget.classList.add('active');
        document.querySelectorAll('[id^="swiper--category-"]').forEach((swiper) => {
            swiper.parentNode.classList.remove('active');
        });
        const carouselId = e.currentTarget.dataset.carouselId;
        document.querySelector(`#${carouselId}`).parentNode.classList.add('active');
    });
});
